import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
  use,
  forwardRef,
  useLayoutEffect,

} from "react";
import VDatePicker4b from "./VDatePicker4b";
import axios from "axios";
//import "./css/global.css";
import "../index.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Fuse from "fuse.js";
import debounce from "lodash/debounce";
import { IconButton, useMediaQuery } from "@mui/material";
import BookingSectionAutoCmplSmallScreen from "./BookingSectionAutoCmplSmallScreen";

import { FaCircleArrowDown, FaTreeCity } from "react-icons/fa6";
import { MdLocationPin } from "react-icons/md";
import { TbRulerMeasure } from "react-icons/tb";
import { merge, orderBy } from "lodash";
import { CiEdit, CiSearch } from "react-icons/ci";

import {
  Dialog,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
  Slide,
} from "@mui/material";
import { CgClose } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";

import { usePath } from "../CommonGlobals/PathContext";
import ComponentLevelLoader from "../CommonGlobals/ComponentLevelLoader";
import PlatformDetector from "../CommonGlobals/PlatformDetector";
import { sendEventTobackend } from "../CommonGlobals/sendEventDataTobackend";
import { useAppGlobalState } from "../CommonGlobals/Store";


const formatDate = (date, separator) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}${separator}${month}${separator}${year}`;
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModifySearchBookingDate = ({
  config = null,
  
  citiesDataUrl = "cities.json",
  onChangeConfigUrl = null,
  onChangeDestinationConfigUrl = null,
  dateSeparator = "-",
  monthDisplayType = "month",
  componentName = "search-journey",
  onSearchModify,
  selectedSourceFromSearch = null,
  selectedDestinationFromSearch = null,
  selectedOnwardFromdate = null,
  selectedOnwardTodate = null,

  showSearchSmallPanel,
  setShowSearchSmallPanel
}) => {
  //const navigate = useNavigate();
  const [cityData, setCityData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [processedCityData, setProcessedCityData] = useState([]);
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);

  const [openSource, setOpenSource] = useState(false);
  const [openDestination, setOpenDestination] = useState(false);

  // const [inputSource, setInputSource] = useState(""); // track typed value
  const [inputDestination, setInputDestination] = useState("");

  // this is the reults save
  const [searchSourceResults, setSearchSourceResults] = useState([]);
  const [searchDestinationResults, setSearchDestinationResults] = useState([]);

  const [isSourceOpen, setIsSourceOpen] = useState(false);
  const [isDestinationOpen, setIsDestinationOpen] = useState(false);

  const [dconfig, setDConfig] = useState(config || null);

  const desRef = useRef();
  const fromDateRef = useRef();
  const toDateRef = useRef();
  const fromDateRef_small = useRef();
  const toDateRef_small = useRef();

  const destinationInputRef = useRef();
  const sourceContainerRef = useRef();
  const destinationContainerRef = useRef();

  const isMobile = useMediaQuery("(max-width:600px)");

  const [currentDate, setCurrentDate] = useState();

  const [openOnDestSelect, setOpenOnDestSelect] = useState(false);

  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const [sendFromTOCalendar, setSendFromTOCalendar] = useState(null);
  const [sendToTOCalendar, setSendToTOCalendar] = useState(null);

  const [globalData, setGlobalData] = useAppGlobalState();
   const { paths } = usePath();
  // fetch city data
  function fetchCityData() {
    // console.log(citiesDataUrl);

    axios
      .get(citiesDataUrl, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // console.log(res);
        if (res.data) {
          // console.log(res.data);
        }
        const cd = JSON.parse(res.data.ResponseData);
        // console.log(cd);
        setCityData(cd);
        // //console.log(cd.cityList);
        // setSearchSourceResults(cd);
        // setSearchDestinationResults(cd);
      })
      .catch((err) => {
        // console.log(err);
      });
  }
  

  useEffect(() => {
    // console.log(processedCityData);
    setSearchSourceResults(processedCityData);
    setSearchDestinationResults(processedCityData);
  }, [processedCityData]);


  useEffect(()=>{
    // console.log(paths.bookingPageUrl);
  },[paths]);

  useEffect(()=>{
    
    //("Config Has Changed");
   // console.log(config);
    setDConfig(config);
  },[config])

  useEffect(() => {
    // console.log(searchSourceResults);
  }, [searchSourceResults]);

  // Fuse instance
  const fuse = useMemo(() => {
    return new Fuse(processedCityData, {
      keys: ["CityName"],
      threshold: 0.2,
      distance: 3,
      minMatchCharLength: 2,
      ignoreLocation: true,
    });
  }, [processedCityData]);

  useEffect(() => {
    fetchCityData();
  }, [citiesDataUrl]);

  useEffect(() => {
    const cdate = formatDate(new Date(), dateSeparator);
    setSelectedFromDate(cdate);
    const parts = cdate.split(/\D+/);
    // console.log(parts);
    var day = parseInt(parts[0]);
    var month = parseInt(parts[1]);
    var year = parseInt(parts[2]);
    if (monthDisplayType == "number") {
      const cur_date3 = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
      setCurrentDate(cur_date3);
    } else {
      var dateObject = new Date(year, month - 1, day);
      // console.log(dateObject);
      const options = { month: "short" };
      const monthName = new Intl.DateTimeFormat("en-US", options).format(
        dateObject
      );
      const cur_date = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
      setCurrentDate(cur_date);
    }
  }, []);

  useEffect(() => {
    if (onChangeConfigUrl) {
      axios
        .get(onChangeConfigUrl, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
         // console.log(res.data);
          // const cd = JSON.parse(res.data.d.data);
          setDConfig(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [onChangeConfigUrl]);

  //   const groupedCities = useMemo(() => {
  //   const map = new Map();

  //   cityData.forEach(c => {
  //     if (!map.has(c.CityID)) {
  //       map.set(c.CityID, {
  //         CityID: c.CityID,
  //         CityName: c.CityName,
  //         ParentCityName: c.ParentCityName || c.CityName,
  //         city: c,
  //         boardingPoints: []
  //       });
  //     }

  //     if (c.BoardingPointID !== 0) {
  //       map.get(c.CityID).boardingPoints.push({
  //         ...c,
  //         isBoardingPoint: true
  //       });
  //     }
  //   });

  //   return Array.from(map.values());
  // }, [cityData]);

  const groupedCities = useMemo(() => {
    const map = new Map();

    cityData.forEach((c) => {
      const entry = {
        CityID: c.CityID,
        CityName:
          c.BoardingPointID === 0
            ? c.CityName
            : c.BoardingPointName.includes(c.CityName)
            ? c.BoardingPointName
            : c.BoardingPointName + `, ${c.CityName}`,
        isBoardingPoint: c.BoardingPointID !== 0,
        BoardingPointID: c.BoardingPointID,
        ParentCityName: c.ParentCityName || c.CityName,
        IsPopularDestination: c.IsPopularDestination,
      };

      if (!map.has(c.CityID)) {
        map.set(c.CityID, [entry]);
      } else {
        map.get(c.CityID).push(entry);
      }
    });

    const groupedData = Array.from(map.values());
    setProcessedCityData(groupedData.flat());
  }, [cityData]);

  //console.log(groupedCities.flat());

  // const customSearch = useCallback(
  //   (query) => {
  //     console.log(groupedCities);
  //      if (!query || query.trim() === "") {

  //       return searchSourceResults;
  //     }

  //     const lower = query.toLowerCase();

  //     // First fuzzy match parent cities
  //     const mainMatches = fuse.search(query).map(r => r.item);

  //     // if (mainMatches.length === 0) {
  //     //   return []; // return empty array instead of previous results
  //     // }

  //     // Convert Fuse results into GROUPED results
  //     const result = [];

  //     // mainMatches.map(city => {
  //     //   const group = groupedCities.find(g => g.CityID === city.CityID);
  //     //   if (group) result.push(group);
  //     // });

  //     // const result = mainMatches
  //     //   .map(r => groupedCities.find(g => g.CityID === r.item.CityID))
  //     //   .filter(Boolean);

  //     mainMatches.forEach(city => {
  //       const group = groupedCities.find(g => g.CityID === city.CityID);
  //       if (group) result.push(group);
  //     });

  //     return result;
  //   },
  //   [groupedCities, fuse]
  // );

  const customSearch = useCallback(
    (query) => {
      if (!query) return processedCityData;

      const lowerQuery = query.toLowerCase();

      if (/^[a-z]$/i.test(query)) {
        return processedCityData?.filter((c) =>
          c.CityName.toLowerCase().startsWith(lowerQuery)
        );
      }

      const fuseResults = fuse.search(query).map((r) => r.item);

      if (fuseResults.length === 0) return [];

      //  const grouped = Object.values(
      //   fuseResults.reduce((acc, city) => {
      //     if (!acc[city.CityID]) {
      //       acc[city.CityID] = [];
      //     }
      //     acc[city.CityID].push(city);
      //     return acc;
      //   }, {})
      // );

      return fuseResults;
    },
    [processedCityData, fuse]
  );

  // Debounced search updates searchResults state
  const debouncedSourceSearch = useMemo(
    () =>
      debounce((query) => {
        const clean = customSearch(query);
        // console.log(clean);
        setSearchSourceResults(clean);
      }, 300),
    [customSearch]
  );

  // Debounced search updates searchResults state
  const debouncedDestinationSearch = useMemo(
    () =>
      debounce((query) => {
        let res = customSearch(query);
        // console.log(res);
        setSearchDestinationResults(customSearch(query));
      }, 500),
    [customSearch]
  );

  // filterOptions for Autocomplete
  const filterSourceOptions = (options, { inputValue }) => {
    if (!inputValue) return options;
    debouncedSourceSearch(inputValue);
    return searchSourceResults;
  };

  // filterOptions for Autocomplete
  const filterDestinationOptions = (options, { inputValue }) => {
    if (!inputValue) return options;
    debouncedDestinationSearch(inputValue);
    return searchDestinationResults;
  };

  const handleOnSelectOpen = () => {
    // destinationInputRef.current?.focus();
    // const event = new KeyboardEvent("keydown", { key: "tab", bubbles: true });
    // destinationInputRef.current?.dispatchEvent(event);
  };

  const handleOutsideClick = useCallback((event) => {
    const scontainer = sourceContainerRef.current;
    const dcontainer = destinationContainerRef?.current;

    // console.log(event.target);

    // console.log(scontainer.contains(event.target));
    // console.log(dcontainer.contains(event.target));

    if (
      scontainer &&
      !scontainer.contains(event.target) &&
      dcontainer &&
      !dcontainer.contains(event.target)
    ) {
      if (event.target.closest(".autocomplete-item")) {
        // console.log("ya");
      } else {
        // console.log("no");
        setIsSourceOpen(false);
        setIsDestinationOpen(false);
      }

      // console.log(event.target.classList);
      // if(event.target.classList.contains('autocomplete-item')){
      //     console.log('ya');
      // }else{
      //   setIsSourceOpen(false);
      //   setIsDestinationOpen(false);
      // }

      // setIsSourceOpen(false);
      // setIsDestinationOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [handleOutsideClick]);

  const handleSwap = () => {
    // console.log(selectedSource);
    // console.log(selectedDestination);
    if (selectedSource != null && selectedDestination != null) {
      setSelectedSource(selectedDestination);
      setSelectedDestination(selectedSource);
    }
    // setSelectedSource(selectedDestination);
    // setSelectedDestination(selectedSource);
  };

  const handleOnSearchClick = () => {

    //console.log(selectedToDate);

    sendEventTobackend("ModifySearchButtonClicked",null,1);

   if(selectedToDate != null ){
      if(selectedFromDate == null || selectedFromDate == ''){
        alert('Please select Valid Journey date');
        return;
      }else{
        //console.log(selectedFromDate);
        //console.log(selectedToDate);
        const frmdt = selectedFromDate.replace(/[/-]/g, "-");
        const todt = selectedToDate.replace(/[/-]/g, "-");

        const reversedFrm = frmdt.split("-").reverse().join("-");
        const reversedTo = todt.split("-").reverse().join("-");  

       // console.log(reversedFrm);
        //console.log(reversedTo);

        const date1 = new Date(reversedFrm);
        const date2 = new Date(reversedTo);

        if (date1 >= date2) {
          alert("Invalid journey date.");
          return;
        }
      }

    }else{
      console.log();
    }


    if (
      selectedSource != null &&
      selectedDestination != null &&
      selectedFromDate != null
    ) {
      // console.log(selectedSource);
      // console.log(selectedDestination);
      // console.log(fromDateRef.current.innerHTML);
      // console.log(toDateRef.current.innerHTML);

      const payload = {
        source: JSON.stringify(selectedSource),
        destination: JSON.stringify(selectedDestination),
        fromDate: selectedFromDate,
        toDate: selectedToDate,
      };

      // console.log(payload);

      const urldata = new URLSearchParams(payload);
      // console.log(urldata.toString());

      const tripslug = `${selectedSource.CityName}-to-${selectedDestination.CityName}`;

      setShowLoader(true);
      var deviceId = null;
      var deviceDaySession = null

      if(window.SessionConstants.DEVICE_INFO_KEY ){
            deviceId =localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
      }

      if(window.SessionConstants.DEVICE_SESSION_KEY){
        deviceDaySession = JSON.parse(localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY)); 
      }


      if(paths.modifyAutoSearch == 0){
        const payloadModify = {
          source: selectedSource,
          destination: selectedDestination,
          fromDate: selectedFromDate,
          toDate: selectedToDate,
          RegistrationUniqueID : deviceId,
          SessionUniqueID :deviceDaySession.sessionId
        };
        window.dispatchEvent(new CustomEvent("postphoneSearch", { detail: payloadModify }));
      }else{
        
        window.location.href = `BookingPage/${tripslug}?${urldata.toString()}`;  
      }


      // console.log(`BookingPage/${tripslug}?${urldata.toString()}`);

      
    }
  };

  const handleModifySearch = () => {
    sendEventTobackend("ModifySearchButtonClicked",null,1);
   if(selectedToDate != null ){
      if(selectedFromDate == null || selectedFromDate == ''){
        alert('Please select Valid Journey date');
        return;
      }else{
       // console.log(selectedFromDate);
        //console.log(selectedToDate);
        const frmdt = selectedFromDate.replace(/[/-]/g, "-");
        const todt = selectedToDate.replace(/[/-]/g, "-");

        const reversedFrm = frmdt.split("-").reverse().join("-");
        const reversedTo = todt.split("-").reverse().join("-");  

       // console.log(reversedFrm);
       // console.log(reversedTo);

        const date1 = new Date(reversedFrm);
        const date2 = new Date(reversedTo);

        if (date1 >= date2) {
          alert("Invalid journey date.");
          return;
        }
      }

    }else{
      console.log();
    }


    if (
      selectedSource != null &&
      selectedDestination != null &&
      selectedFromDate != null
    ) {
      // console.log(selectedSource);
      // console.log(selectedDestination);
      // console.log(fromDateRef.current.innerHTML);
      // console.log(toDateRef.current.innerHTML);

      const payload = {
        source: JSON.stringify(selectedSource),
        destination: JSON.stringify(selectedDestination),
        fromDate: selectedFromDate,
        toDate: selectedToDate,
      };

      // console.log(payload);

      //onSearchModify(payload); 

      const urldata = new URLSearchParams(payload);
      // console.log(urldata.toString());
       setShowLoader(true);

       var deviceId = null;
      var deviceDaySession = null

       if (
             PlatformDetector.isAndroidWebView() ||     PlatformDetector.isIOSWebView()
           ){
       
              if(window.RegistrationUniqueIDFromMobile ){
                     deviceId =window.RegistrationUniqueIDFromMobile;
                 }
           
                 if(window.SessionUniqueIDFromMobile){
                    deviceDaySession = {sessionId:window.SessionUniqueIDFromMobile}; 
                 }
       
           }else{
                 if(window.SessionConstants.DEVICE_INFO_KEY ){
                     deviceId =localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
                 }
           
                 if(window.SessionConstants.DEVICE_SESSION_KEY){
                    deviceDaySession = JSON.parse(localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY)); 
                    deviceDaySession = deviceDaySession.sessionId;
                 }
           }

        

       

        

       if(paths.modifyAutoSearch == 0){
          const payloadModify = {
           source: selectedSource,
            destination: selectedDestination,
            fromDate: selectedFromDate,
            toDate: selectedToDate,
            RegistrationUniqueID : deviceId,
            SessionUniqueID : deviceDaySession
          };
          window.dispatchEvent(new CustomEvent("postphoneSearch", { detail: payloadModify }));
       }else{
         const tripslug = `${selectedSource.CityName}-to-${selectedDestination.CityName}`;
         window.location.href = `${paths.bookingPageUrl}/${tripslug}?${urldata.toString()}`;  
       }
       
      // const tripslug = `${selectedSource.CityName}-to-${selectedDestination.CityName}`;
      // window.location.href = `${paths.bookingPageUrl}/${tripslug}?${urldata.toString()}`;

      // if(PlatformDetector.isAndroidWebView() || PlatformDetector.isIOSWebView()){
      //    window.location.href = `${paths.bookingPageUrl}/${tripslug}?${urldata.toString()}`;
      // }else{
      //    window.location.href = `${paths.bookingPageUrl}/${tripslug}?${urldata.toString()}`;
      // }
      // console.log(tripslug);
      // console.log(`${paths.bookingPageUrl}/${tripslug}?${urldata.toString()}`);
     
    }
  };


  const [dateFormatwithMonthName,setDateFormatwithMonthName] = useState("");
  const [selectedDateDayName,setSelectedDateDayName] = useState("");

  const [todateFormatwithMonthName,setTodateFormatwithMonthName] = useState("");
  const [selectedToDateDayName,setSelectedToDateDayName] = useState("");

  useEffect(() => {
    if (selectedSourceFromSearch) {
      setSelectedSource(selectedSourceFromSearch);
    }
    if (selectedDestinationFromSearch) {
      setSelectedDestination(selectedDestinationFromSearch);
    }
    if (selectedOnwardFromdate) {
      setSelectedFromDate(selectedOnwardFromdate);
      let result_with_slash = selectedOnwardFromdate.replace(/-/g, "/");
      // console.log(result_with_slash);
      setSendFromTOCalendar(result_with_slash);  
      let result = selectedOnwardFromdate.replace(/\/\s*-/g, "-");
      const parts = result.split(/\D+/);
      // console.log(parts);
                          var day = parseInt(parts[0]);
                          var month = parseInt(parts[1]);
                          var year = parseInt(parts[2]); 

                          var dateObject = new Date(year, month - 1, day);
                            // console.log(dateObject);
                            const options = { month: "short" };
                            const monthName = new Intl.DateTimeFormat(
                              "en-US",
                              options
                            ).format(dateObject);

                            const dayOptions = { weekday: "long" }; // "short" → Mon, Tue; "narrow" → M, T
                          const dayName = new Intl.DateTimeFormat("en-US", dayOptions).format(dateObject);
                          // console.log("Day:", dayName);

                            fromDateRef.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
                            // console.log(`${day}${dateSeparator}${monthName}${dateSeparator}${year}`);
                            setDateFormatwithMonthName(`${day}${dateSeparator}${monthName}${dateSeparator}${year}`);
                            setSelectedDateDayName(dayName);
      //fromDateRef.current.innerHTML = selectedOnwardFromdate; 
      //console.log("setting from date small ref to date fromDateRef_small");
      // console.log(fromDateRef_small.current);

      if(fromDateRef_small.current){
        fromDateRef_small.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
      }else{
        //console.log("from date small ref not found fromDateRef_small");
      }
     
    }
    if (selectedOnwardTodate) {
      // setSelectedToDate(selectedOnwardTodate);
      // toDateRef.current.innerHTML = selectedOnwardTodate;


      setSelectedToDate(selectedOnwardTodate);
      let result_with_slash = selectedOnwardTodate.replace(/-/g, "/");
      // console.log(result_with_slash);
      setSendToTOCalendar(result_with_slash);  
      let result = selectedOnwardTodate.replace(/\/\s*-/g, "-");
      const parts = result.split(/\D+/);
     // console.log(parts);
                          var day1 = parseInt(parts[0]);
                          var month1 = parseInt(parts[1]);
                          var year1 = parseInt(parts[2]); 

                          var dateObject1 = new Date(year1, month1 - 1, day1);
                            // console.log(dateObject);
                            const options = { month: "short" };
                            const monthName = new Intl.DateTimeFormat(
                              "en-US",
                              options
                            ).format(dateObject1);

                            const dayOptions = { weekday: "long" }; // "short" → Mon, Tue; "narrow" → M, T
                          const dayName = new Intl.DateTimeFormat("en-US", dayOptions).format(dateObject1);
                          // console.log("Day:", dayName);

                            toDateRef.current.innerHTML = `${day1}${dateSeparator}${monthName}${dateSeparator}${year1}`;
                            // console.log(`${day}${dateSeparator}${monthName}${dateSeparator}${year}`);
                            setTodateFormatwithMonthName(`${day1}${dateSeparator}${monthName}${dateSeparator}${year1}`);
                            setSelectedToDateDayName(dayName);
      //fromDateRef.current.innerHTML = selectedOnwardFromdate; 
       if(toDateRef_small.current){
        //console.log("setting to date small ref to date");
        toDateRef_small.current.innerHTML = `${day1}${dateSeparator}${monthName}${dateSeparator}${year1}`;
      }else{
        // console.log("to date small ref not found");
      } 
    }
  }, [
    selectedSourceFromSearch,
    selectedDestinationFromSearch,
    selectedOnwardFromdate,
    selectedOnwardTodate,
  ]);

 // const [showSearchSmallPanel, setShowSearchSmallPanel] = useState(false);

  const showOrHideSearch = () => {
    setShowSearchSmallPanel((perv) => !perv);
  };

  // const handleNativeBackButtonClicked = () => {
  //     console.log("Native Back Button Clicked");
  //     setShowSearchSmallPanel(false);
  // }

  //  useEffect(() => {    
    
  //         window.addEventListener('nativeHarwareBackButtonClick', handleNativeBackButtonClicked);
    
  //         return () => {
  //           window.removeEventListener('nativeHarwareBackButtonClick', handleNativeBackButtonClicked);
  //         };
    
    
  //     },[]);

  useEffect(() => {
    console.log(showSearchSmallPanel);
    console.log(fromDateRef_small)

     setGlobalData((prev) => ({
      ...prev,
      isSmallSearchOpen: showSearchSmallPanel,
     }));
   
  }, [showSearchSmallPanel]);

  useEffect(() => {console.log("Global Data:");console.log(globalData)},[globalData]);

  const handleSearchClose = () => {
    setShowSearchSmallPanel(false);
  };

  const handleSearchToggle = () => {
    // console.log("toggle");
    setShowSearchSmallPanel((perv) => !perv);
  };


  useEffect(() => {
    // console.log(fromDateRef_small)
  }, [fromDateRef_small]);


  useLayoutEffect(() => {
    setTimeout(() => {
      // console.log(fromDateRef_small); 
      if(fromDateRef_small != undefined && fromDateRef_small.current && selectedFromDate){
        let result = selectedFromDate.replace(/\/\s*-/g, "-");
      const parts = result.split(/\D+/);
      // console.log(parts);
                          var day = parseInt(parts[0]);
                          var month = parseInt(parts[1]);
                          var year = parseInt(parts[2]); 

                          var dateObject = new Date(year, month - 1, day);
                            // console.log(dateObject);
                            const options = { month: "short" };
                            const monthName = new Intl.DateTimeFormat(
                              "en-US",
                              options
                            ).format(dateObject);
                            fromDateRef_small.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
        
      }


      if(toDateRef_small != undefined && toDateRef_small.current && selectedToDate){
        let result = selectedToDate.replace(/\/\s*-/g, "-");  
      const parts = result.split(/\D+/);
      // console.log(parts);
                          var day2 = parseInt(parts[0]);
                          var month2 = parseInt(parts[1]);
                          var year2 = parseInt(parts[2]); 

                          var dateObject2 = new Date(year2, month2 - 1, day2);
                            // console.log(dateObject);
                            const options = { month: "short" };
                            const monthName = new Intl.DateTimeFormat(
                              "en-US",
                              options
                            ).format(dateObject2);
                            toDateRef_small.current.innerHTML = `${day2}${dateSeparator}${monthName}${dateSeparator}${year2}`;
        
      }
    
    
    
    
    
      }, 100);
    // console.log(fromDateRef_small);
  // if (fromDateRef_small.current && selectedFromDate) {
  //   fromDateRef_small.current.innerHTML = selectedFromDate;
  // }
}, [showSearchSmallPanel, selectedFromDate]);

  return (
    <>
      <div className="modify-search-booking-date-container">
        <section className="ms-booking-section">
          <div className="ms-booking-container">
            <div className="ms-booking-header">
             {
                todateFormatwithMonthName && selectedToDateDayName ?
                <>

                   <div className="onward-and-return-container">

                      <div className="onward-data">

                           <span> {selectedSource?.CityName} to { selectedDestination?.CityName } </span>

                          <span>{dateFormatwithMonthName}, {selectedDateDayName}</span>

                          

                      </div>

                      <div className="return-data">
                          <span> { selectedDestination?.CityName }  to  {selectedSource?.CityName} </span>

                          <span> {todateFormatwithMonthName}, {selectedToDateDayName}</span>
                      </div>

                   </div>

                </>
                
                
                :

                <>

                   <div className="param-search-data">
                      <span> {selectedSource?.CityName} to { selectedDestination?.CityName } </span>

                      <span>{dateFormatwithMonthName}, {selectedDateDayName}</span>
                  
                
                    </div>

                </>




             }

              
           
              

              <button
                className="journey-edit-button"
                onClick={() => handleSearchToggle()}
              >
                <CiEdit className="edit-icon" />
              </button>
            </div>

            <div className="container">
              <div className={"ms-booking-content"}>
                <div className="ms-source-destination-section">
                  {isMobile ? (
                   <><span></span></>
                  ) : (
                    <>
                      {/* Desktop version */}
                      <div className="ms-sd-input-section">
                        <div
                          className="ms-source"
                          style={{ padding: "0px 0px" }}
                          ref={sourceContainerRef}
                        >
                          <Autocomplete
                            onClose={() => {
                              setIsSourceOpen(false);
                              // setIsDestinationOpen(true);
                              // console.log('close id done');
                              // open destination after small delay

                              // small delay lets MUI finish closing
                            }}
                            onOpen={() => {
                              setIsSourceOpen(true);
                              setIsDestinationOpen(false);
                            }}
                            value={selectedSource}
                            open={isSourceOpen}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                setSelectedSource(newValue);
                                sendEventTobackend("ModifySourceClicked",null,1);
                                setTimeout(() => {
                                  setIsDestinationOpen(true);

                                  // now safely focus destination input
                                  // console.log("focus destination input");
                                  if (destinationInputRef.current) {
                                    const input =
                                      destinationInputRef.current.querySelector(
                                        "input"
                                      );
                                    input?.focus();
                                  }
                                }, 250);
                              } else {
                                setSelectedSource(null);
                              }
                            }}
                            // onInputChange={(e, value) => setInputSource(value)}
                            onInputChange={(e, value) =>
                              debouncedSourceSearch(value)
                            }
                            filterOptions={filterSourceOptions}
                            forcePopupIcon={false}
                            options={searchSourceResults}
                            sx={{
                              ".MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              ".MuiInput-underline:after": {
                                borderBottom: "none",
                              },
                              ".MuiInput-underline:before": {
                                borderBottom: "none",
                              },
                              ".MuiFilledInput-underline:after": {
                                borderBottom: "none",
                              },
                              ".MuiFilledInput-underline:before": {
                                borderBottom: "none",
                              },

                              paddingRight: "40px",
                            }}
                            getOptionLabel={(option) =>
                              typeof option === "string"
                                ? option
                                : option.inputValue || option.CityName
                            }
                            renderOption={(props, option) => (
                              <li key={option.CityID} {...props}>
                                <div
                                  className="autocomplete-item"
                                  style={{ color: "#1f1f1f" }}
                                >
                                  {!option.isBoardingPoint ? (
                                    <small className="icon" >
                                      <FaTreeCity />
                                    </small>
                                  ) : (
                                    <small
                                      className="icon"
                                      style={{ paddingLeft: "20px" }}
                                    >
                                      <MdLocationPin />
                                    </small>
                                  )}

                                  {option.CityName}
                                </div>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={""}
                                placeholder="Source"
                                size="small"
                                className="autocomplete-input2"
                                InputLabelProps={{
                                  ...params.InputLabelProps,
                                  sx: {
                                    ...params.InputLabelProps.sx,
                                    color: "#1f1f1f",
                                    fontWeight: "bold",
                                    paddingLeft: "20px",
                                    // Change color on focus
                                    "&.Mui-focused": {
                                      color: "#150E2D",
                                    },
                                  },
                                }}
                              />
                            )}
                          />
                        </div>
                        <div
                          className="ms-swap-icon"
                          onClick={() => handleSwap()}
                        ></div>
                        <div
                          className="ms-destination"
                          style={{ padding: "0px 0px" }}
                          ref={destinationContainerRef}
                        >
                          <Autocomplete
                            value={selectedDestination}
                            onClose={() => setIsDestinationOpen(false)}
                            onOpen={() => {
                              setIsDestinationOpen(true);
                              setOpenOnDestSelect(false);
                            }}
                            open={isDestinationOpen}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                setSelectedDestination(newValue);
                                sendEventTobackend("ModifyDestinationClicked",null,1);
                                setTimeout(() => {
                                  setOpenOnDestSelect(true);
                                }, 100);

                                if (onChangeDestinationConfigUrl != null) {
                                  axios
                                    .get(onChangeDestinationConfigUrl, {
                                      headers: {
                                        "Content-Type": "application/json",
                                      },
                                    })
                                    .then((res) => {
                                      // console.log(res);

                                      if (res.data) {
                                        if (config) {
                                          const mconfig = merge(
                                            {},
                                            config,
                                            res.data
                                          );

                                          // console.log(mconfig);
                                          setDConfig(mconfig);
                                        } else {
                                          // console.log(
                                          //   "local data not available"
                                          // );
                                        }
                                      }
                                    })
                                    .catch((err) => {
                                      console.log(err);
                                    });
                                }
                              } else {
                                setSelectedDestination(null);
                              }
                            }}
                            onInputChange={(e, value) =>
                              debouncedDestinationSearch(value)
                            }
                            filterOptions={filterDestinationOptions}
                            forcePopupIcon={false}
                            options={searchDestinationResults}
                            sx={{
                              ".MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              ".MuiInput-underline:after": {
                                borderBottom: "none",
                              },
                              ".MuiInput-underline:before": {
                                borderBottom: "none",
                              },
                              ".MuiFilledInput-underline:after": {
                                borderBottom: "none",
                              },
                              ".MuiFilledInput-underline:before": {
                                borderBottom: "none",
                              },
                            }}
                            getOptionLabel={(option) =>
                              typeof option === "string"
                                ? option
                                : option.inputValue || option.CityName
                            }
                            renderOption={(props, option) => (
                              <li key={option.CityID} {...props}>
                                <div className="ms-autocomplete-item">
                                  {!option.isBoardingPoint ? (
                                    <small className="icon" style={{ paddingRight: "15px" }}>
                                      <FaTreeCity />
                                    </small>
                                  ) : (
                                    <small
                                      className="icon"
                                      style={{ paddingLeft: "20px" }}
                                    >
                                      <MdLocationPin />
                                    </small>
                                  )}

                                  {option.CityName}
                                </div>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={""}
                                placeholder="Destination"
                                size="small"
                                className="ms-autocomplete-input2"
                                ref={destinationInputRef}
                                InputLabelProps={{
                                  ...params.InputLabelProps,
                                  sx: {
                                    ...params.InputLabelProps.sx,
                                    color: "#1f1f1f",
                                    fontWeight: "bold",
                                    paddingLeft: "20px",
                                    // Change color on focus
                                    "&.Mui-focused": {
                                      color: "#150E2D",
                                    },
                                  },
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {/* Date pickers */}
                  <div className="ms-datepickers-section">
                    <div className="ms-datepickers">
                      {/* <input
                        type="text"
                        ref={fromDateRef}
                        id="from-date"
                        placeholder="11-09-2025"
                    /> */}
                      <div className="ms-input-element" ref={fromDateRef}>
                        {" "}
                        <span style={{ color: "#1c1c1c" }}>
                          {" "}
                          {currentDate}{" "}
                        </span>
                      </div>

                      <VDatePicker4b
                        targetRef={fromDateRef}
                        onDateSelect={(date) => {
                          setSelectedFromDate(date);
                          //fromDateRef.current.innerHTML = date;
                          sendEventTobackend("ModifyOnwardDateSelected",null,1);
                          //console.log(date);
                          const parts = date.split(/\D+/);
                          // console.log(parts);
                          var day = parseInt(parts[0]);
                          var month = parseInt(parts[1]);
                          var year = parseInt(parts[2]);
                          if (monthDisplayType == "number") {
                            fromDateRef.current.innerHTML = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
                          } else {
                            var dateObject = new Date(year, month - 1, day);
                            // console.log(dateObject);
                            const options = { month: "short" };
                            const monthName = new Intl.DateTimeFormat(
                              "en-US",
                              options
                            ).format(dateObject);
                            fromDateRef.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
                          }
                        }}
                        minDate={"10/01/2024"}
                        configFromApi={dconfig ? dconfig : null}
                        type="text"
                        openOnClose={openOnDestSelect}
                        currentDateFromParent={sendFromTOCalendar}
                      />

                      {
                        paths.modifyAutoSearch == 0 ?<></>:<>
                           <VDatePicker4b
                        targetRef={toDateRef}
                        onDateSelect={(date) => {
                          //toDateRef.current.innerHTML = date;

                          setSelectedToDate(date);
                          sendEventTobackend("ModifyReturnDateSelected",null,1);
                          const parts = date.split(/\D+/);
                          // console.log(parts);
                          var day = parseInt(parts[0]);
                          var month = parseInt(parts[1]);
                          var year = parseInt(parts[2]);
                          if (monthDisplayType == "number") {
                            toDateRef.current.innerHTML = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
                          } else {
                            var dateObject = new Date(year, month - 1, day);
                            // console.log(dateObject);
                            const options = { month: "short" };
                            const monthName = new Intl.DateTimeFormat(
                              "en-US",
                              options
                            ).format(dateObject);
                            toDateRef.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
                          }
                        }}
                        minDate={"10/01/2024"}
                        configFromApi={dconfig ? dconfig : null}
                        
                      />
                      <div className="ms-input-element" ref={toDateRef}>
                        {" "}
                        <span style={{ color: "#A1A1A1", fontWeight: 400 }}>
                          Return
                        </span>
                      </div>
                        </>
                      }
                    </div>
                  </div>
                  <div className="ms-search-button-section">
                    {componentName == "home" ? (
                      <button
                        className="ms-search-button"
                        onClick={() => {
                          handleOnSearchClick();
                        }}
                      >
                        Search
                      </button>
                    ) : (
                      <button
                        className="ms-search-button"
                        onClick={() => {
                          handleModifySearch();
                        }}
                      >
                        {" "}
                        <CiSearch />{" "}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Dialog
        open={showSearchSmallPanel}
        onClose={handleSearchClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            m: 0,
            position: "fixed",
            bottom: 0,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            width: "100%",
            height: { xs: "45vh", md: "45vh" },
            display: "flex",
            flexDirection: "row",
            overflow: "hidden",
            backgroundColor: "#F4CC08",
          },
        }}
      >
        <Box sx={{ position: "absolute", top: 8, right: 8 }}>
          <IconButton
                            edge="start"
                            onClick={handleSearchClose}
                            aria-label="close"
                            sx={{ color: '#2D3FA8', border:"1px solid #2D3FA8", borderRadius:"50%", '&:hover': {
                                  color: '#fff',
                                  backgroundColor: '#2D3FA8',
                                  },
                                  height:"30px",
                                  width:"30px",
                              }}
          
                          >
                            <IoMdClose />
                          </IconButton>
        </Box>

        <Box sx={{ flex: 1, p: 2, overflowY: "auto",marginTop:'25px' }}>
          <div className="modify-search-booking-date-container">
            <section className="ms-booking-container-mobile">
                <div className="ms-booking-content-mobile">

                    <div className="ms-source-destination-section-mobile">


                        <div className="ms-sd-input-section">
                        <div
                          className="ms-source"
                          style={{ padding: "0px 0px" }}
                        >
                          <div onClick={() => setOpenSource(true)}>
                            <TextField
                              value={selectedSource?.CityName || ""}
                              placeholder="Source"
                              fullWidth
                              size="small"
                              className="autocomplete-input2"
                              sx={{
                                ".MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                ".MuiInput-underline:after": {
                                  borderBottom: "none",
                                },
                                ".MuiInput-underline:before": {
                                  borderBottom: "none",
                                },
                                ".MuiFilledInput-underline:after": {
                                  borderBottom: "none",
                                },
                                ".MuiFilledInput-underline:before": {
                                  borderBottom: "none",
                                },

                                ".autocomplete-input2": {
                                  color: "#1f1f1f",
                                  fontWeight: "bold",
                                  paddingLeft: "20px",
                                },
                              }}
                              InputProps={{
                                readOnly: true, // Make the input field read-only
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className="ms-swap-icon"
                          onClick={() => handleSwap()}
                        ></div>
                        <div
                          className="ms-destination"
                          style={{ padding: "0px 0px" }}
                        >
                          <div onClick={() => setOpenDestination(true)}>
                            <TextField
                              value={selectedDestination?.CityName || ""}
                              placeholder="Destination"
                              fullWidth
                              size="small"
                              className="autocomplete-input2"
                              sx={{
                                ".MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                ".MuiInput-underline:after": {
                                  borderBottom: "none",
                                },
                                ".MuiInput-underline:before": {
                                  borderBottom: "none",
                                },
                                ".MuiFilledInput-underline:after": {
                                  borderBottom: "none",
                                },
                                ".MuiFilledInput-underline:before": {
                                  borderBottom: "none",
                                },

                                ".autocomplete-input2": {
                                  color: "#1f1f1f",
                                  fontWeight: "bold",
                                  paddingLeft: "20px",
                                },
                              }}
                              InputProps={{
                                readOnly: true, // Make the input field read-only
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <BookingSectionAutoCmplSmallScreen
                        open={openSource}
                        onClose={() => setOpenSource(false)}
                        value={selectedSource}
                        setValue={setSelectedSource}
                        cityData={processedCityData}
                        fuse={fuse}
                        label={"Source"}
                      />

                      <BookingSectionAutoCmplSmallScreen
                        open={openDestination}
                        onClose={() => {
                          setOpenDestination(false);
                          if (onChangeDestinationConfigUrl != null) {
                            axios
                              .get(onChangeDestinationConfigUrl, {
                                headers: {
                                  "Content-Type": "application/json",
                                },
                              })
                              .then((res) => {
                                // console.log(res);

                                if (res.data) {
                                  if (config) {
                                    const mconfig = merge({}, config, res.data);

                                    // console.log(mconfig);
                                    setDConfig(mconfig);
                                  } else {
                                    // console.log("local data not available");
                                  }
                                }
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }
                        }}
                        value={selectedDestination}
                        setValue={setSelectedDestination}
                        cityData={processedCityData}
                        fuse={fuse}
                        label={"Destination"}
                      />






                      {/* Date pickers */}
                 
                      <div className="ms-datepickers-section">
                    <div className="ms-datepickers">
                      {/* <input
                        type="text"
                        ref={fromDateRef}
                        id="from-date"
                        placeholder="11-09-2025"
                    /> */}
                      <div className="ms-input-element" ref={fromDateRef_small}>
                        {" "}
                        <span style={{ color: "#1c1c1c" }}>
                          {" "}
                          {currentDate}{" "}
                        </span>
                      </div>

                      <VDatePicker4b
                        targetRef={fromDateRef_small}
                        onDateSelect={(date) => {
                          setSelectedFromDate(date);
                          //fromDateRef.current.innerHTML = date;

                          //console.log(date);
                          const parts = date.split(/\D+/);
                          // console.log(parts);
                          var day = parseInt(parts[0]);
                          var month = parseInt(parts[1]);
                          var year = parseInt(parts[2]);
                          if (monthDisplayType == "number") {
                            fromDateRef_small.current.innerHTML = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
                          } else {
                            var dateObject = new Date(year, month - 1, day);
                            // console.log(dateObject);
                            const options = { month: "short" };
                            const monthName = new Intl.DateTimeFormat(
                              "en-US",
                              options
                            ).format(dateObject);
                            fromDateRef_small.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
                          }
                        }}
                        minDate={"10/01/2024"}
                        configFromApi={dconfig ? dconfig : null}
                        type="text"
                        openOnClose={openOnDestSelect}
                        currentDateFromParent={sendFromTOCalendar}
                      />
                      {
                        paths.modifyAutoSearch == 0 ?<></>:<>

                          <VDatePicker4b
                        targetRef={toDateRef_small}
                        onDateSelect={(date) => {
                          //toDateRef.current.innerHTML = date;

                          setSelectedToDate(date);
                          const parts = date.split(/\D+/);
                          // console.log(parts);
                          var day = parseInt(parts[0]);
                          var month = parseInt(parts[1]);
                          var year = parseInt(parts[2]);
                          if (monthDisplayType == "number") {
                            toDateRef_small.current.innerHTML = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
                          } else {
                            var dateObject = new Date(year, month - 1, day);
                            // console.log(dateObject);
                            const options = { month: "short" };
                            const monthName = new Intl.DateTimeFormat(
                              "en-US",
                              options
                            ).format(dateObject);
                            toDateRef_small.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
                          }
                        }}
                        minDate={"10/01/2024"}
                        configFromApi={dconfig ? dconfig : null}
                        currentDateFromParent={sendToTOCalendar}
                      />

                       <div className="ms-input-element" ref={toDateRef_small}>
                        {" "}
                        <span style={{ color: "#A1A1A1", fontWeight: 400 }}>
                          {
                            selectedToDate == null ? "Return" : selectedToDate
                          }
                        </span>
                      </div>



                        </>
                      }

                      

                     


                    </div>
                  </div>
                  <div className="ms-search-button-section">
                    {componentName == "home" ? (
                      <button
                        className="ms-search-button"
                        onClick={() => {
                          handleOnSearchClick();
                        }}
                      >
                        Search
                      </button>
                    ) : (
                      <button
                        className="ms-search-button"
                        onClick={() => {
                          handleModifySearch();
                        }}
                      >
                        Modify Search
                        {/* <CiSearch />{" "} */}
                      </button>
                    )}
                  </div>












                    </div>
                     

                      

                </div>


                 







            </section>

          </div>
        </Box>
      </Dialog>

      <ComponentLevelLoader isLoading={showLoader} />
    </>
  );
};

export default ModifySearchBookingDate;
